import React from 'react';
import PropTypes from 'prop-types';

export default function arrowRenderer({ onMouseDown }) {
	return React.createElement('span', {
		className: 'Select-arrow',
		onMouseDown: onMouseDown
	});
};

arrowRenderer.propTypes = {
	onMouseDown: PropTypes.func
};


//////////////////
// WEBPACK FOOTER
// /root/social-native/socialnative-web/node_modules/react-select/lib/utils/defaultArrowRenderer.js
// module id = 2416
// module chunks = 69